import { Snippet } from '../../dataModels';

export const standingOrderSnippet: Snippet = {
  shiftsummaryDisplyId: '0b601885-bbf3-ec11-9147-005056b29cce',
  name: 'Standing Order',
  displayName: 'Standing Order',
  description: null,
  order: 7,
  type: 'StandingOrder',
  enableEdit: 'False',
  enableComment: false,
  isEdited: false,
  maxRows: 20,
  canAddDeleteRows: false,
  configuration: {
    rowTitleKey: 'name',
    columnCount: 13,
    columns: [
      {
        id: 1,
        name: 'standingOrderId',
        displayName: 'standingOrderId',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'False',
      },
      {
        id: 2,
        name: 'name',
        displayName: 'Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'description',
        displayName: 'Description',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 4,
        name: 'categoryDisplayName',
        displayName: 'Category',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 5,
        name: 'productDisplayName',
        displayName: 'Product',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 6,
        name: 'statusDisplayName',
        displayName: 'Status',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 7,
        name: 'assetDisplayName',
        displayName: 'Asset',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 8,
        name: 'isAuthorizationNeeded',
        displayName: 'Authorization  Needed',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 9,
        name: 'planStartTime',
        displayName: 'Planned Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 10,
        name: 'planEndTime',
        displayName: 'Planned End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 11,
        name: 'actualStartTime',
        displayName: 'Actual Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 12,
        name: 'actualEndTime',
        displayName: 'Actual End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 13,
        name: 'planNote',
        displayName: 'Plan Note',
        controlType: 'Text',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: null,
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 3,
      rowData: [
        {
          standingOrderId: '9b5f4d48-0e5c-4450-a0d2-6ac91bdded71',
          name: 'Mobile app test 6',
          description: 'Test',
          categoryDisplayName: 'General',
          productDisplayName: 'None',
          statusDisplayName: 'Planned',
          assetDisplayName: 'Field1',
          isAuthorizationNeeded: 'True',
          planStartTime: '2022-06-23 18:02:00',
          planEndTime: '',
          actualStartTime: '',
          actualEndTime: '',
          planNote: 'Test SO 6',
        },
        {
          standingOrderId: 'cc8f35b6-e6b8-4bae-b865-22d8cdcbe81c',
          name: 'Mobile app 7',
          description: 'Test',
          categoryDisplayName: 'Test1',
          productDisplayName: 'None',
          statusDisplayName: 'Activated',
          assetDisplayName: 'Field1',
          isAuthorizationNeeded: 'False',
          planStartTime: '2022-06-23 18:45:00',
          planEndTime: '',
          actualStartTime: '2022-06-23 18:45:15',
          actualEndTime: '',
          planNote: 'Test',
        },
        {
          standingOrderId: '7160f350-9987-48f2-a4c8-f8081e853905',
          name: 'Mobile app test 2',
          description: 'Mobile app test 2',
          categoryDisplayName: 'General',
          productDisplayName: 'None',
          statusDisplayName: 'Activated',
          assetDisplayName: 'Field1',
          isAuthorizationNeeded: 'False',
          planStartTime: '2022-05-12 19:20:00',
          planEndTime: '',
          actualStartTime: '2022-05-12 19:20:12',
          actualEndTime: '',
          planNote: 'Mobile app test 2',
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
};
